import { useEffect, useState } from "react";

type Props = {
  // 0..100
  percent: number;
  // Внешний диаметр в px
  size?: number;
  // Толщина обводки в px
  stroke?: number;
  // Содержимое по центру (обычно текст: "47%" или "3/22")
  children?: React.ReactNode;
  // Цвет заполненной части. Дефолт — акцент Telegram-темы.
  color?: string;
  // Цвет фоновой части кольца (трек).
  trackColor?: string;
};

// Apple Watch — стиль кольца. SVG, без зависимостей.
// На mount стартует с 0% и анимирует stroke-dashoffset до целевого значения —
// мелкая, но приятная деталь, оживляет дашборд.
export default function ProgressRing({
  percent,
  size = 96,
  stroke = 9,
  children,
  color,
  trackColor,
}: Props) {
  const clamped = Math.max(0, Math.min(100, percent));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;

  const [animatedPct, setAnimatedPct] = useState(0);
  useEffect(() => {
    // requestAnimationFrame чтобы initial рендер с 0 успел зафиксироваться,
    // и переход stroke-dashoffset реально проигрался.
    const raf = requestAnimationFrame(() => setAnimatedPct(clamped));
    return () => cancelAnimationFrame(raf);
  }, [clamped]);

  const offset = circumference * (1 - animatedPct / 100);

  return (
    <div
      className="ring"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={trackColor ?? "var(--card-surface-strong)"}
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color ?? "var(--tg-theme-button-color, #2481cc)"}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 700ms ease-out" }}
        />
      </svg>
      {children !== undefined && <div className="ring-label">{children}</div>}
    </div>
  );
}
